import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import Panel from "../../../components/panel/panel";
import * as XLSX from "xlsx";
import html2pdf from "html2pdf.js";
import { formatIsoDate } from "../../../utils/formatDate";


export default function TableBankSync({ syncData, totalRecords, currentAccountName, valueTemplate, errors, loading }) {

  const safeData = Array.isArray(syncData) ? syncData : [];

  const formatDateForPDF = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('pt-BR');
    } catch {
      return dateString;
    }
  };

  const formatValueForPDF = (value) => {
    if (!value) return '-';
    try {
      const numValue = parseFloat(value);
      return numValue.toLocaleString('pt-BR', { 
        style: 'currency', 
        currency: 'BRL' 
      });
    } catch {
      return value;
    }
  };



  const handleExportExcel = () => {
    const dataForExcel = safeData.map(item => ({
      'ID da Parcela': item.installment_id,
      'ID da Conta': item.current_account_id,
      'Valor do Pagamento': item.payment_value,
      'Data do Pagamento': item.payment_date
    }));

    const ws = XLSX.utils.json_to_sheet(dataForExcel);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sincronização");
    XLSX.writeFile(wb, `sincronizacao_bancaria_${new Date().toISOString().split("T")[0]}.xlsx`);
  };

   const handleExportPDF = () => {
      const element = document.getElementById("banks-sync-report");
      if (!element) return;

      const options = {
        margin: [10, 10, 10, 10],
        filename: `Sincronizacao_bancaria_${new Date().toISOString().split("T")[0]}_${currentAccountName?.replace(/\s+/g, '_')}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { 
          scale: 2,
          useCORS: true,
          allowTaint: true
        },
        jsPDF: { 
          unit: "mm", 
          format: "a3", 
          orientation: "landscape"
        },
      };

      html2pdf()
        .from(element)
        .set(options)
        .save();
    };

  return (
    <Panel
      title={`Resultado da Sincronização - ${totalRecords} parcelas sincronizadas`}
      buttonPlanilha={
        <div className="d-flex align-items-center gap-2">
                <Button
                  icon="fa fa-file-pdf"
                  className="p-button-secondary cursor-pointer"
                  rounded
                  onClick={handleExportPDF}
                  tooltip="Exportar PDF"
                  tooltipOptions={{ position: 'top' }}
                />
                <Button
                  icon="fa fa-file-excel"
                  className="p-button-success cursor-pointer"
                  rounded
                  onClick={handleExportExcel}
                  disabled={!safeData || safeData.length === 0}
                  tooltip={!safeData || safeData.length === 0 ? "Nenhum dado para exportar" : "Exportar Excel"}
                  tooltipOptions={{ position: 'top' }}
                />
              </div>
            }
          >
            <>
              <hr className="my-3" />
              <div className="px-2 pb-3" id="banks-sync-report">
                <DataTable
                  value={safeData}
                  rows={25}
                  paginator
                  stripedRows
                  showGridlines
                  rowsPerPageOptions={[25, 50, 100]}
                  emptyMessage={
                    <div style={{ textAlign: "center" }}>
                      Nenhuma parcela foi processada na sincronização.
                    </div>
                  }
                  tableStyle={{ minWidth: "0.8rem", fontSize: "0.75rem" }}
                >
                  <Column
                    field="installment_id"
                    header="ID da Parcela"
                    sortable
                    style={{ minWidth: "120px" }}
                  />
                  <Column
                    field="current_account_id"
                    header="ID da Conta"
                    sortable
                    style={{ minWidth: "120px" }}
                  />
                  <Column
                    field="payment_value"
                    header="Valor do Pagamento"
                    sortable
                    body={(rowData) => valueTemplate ? valueTemplate(rowData, "payment_value") : formatValueForPDF(rowData.payment_value)}
                    style={{ minWidth: "150px" }}
                  />
                  <Column
                    field="payment_date"
                    header="Data do Pagamento"
                    sortable
                    body={(rowData) => formatDateForPDF(rowData.payment_date)}
                    style={{ minWidth: "130px" }}
                  />
                </DataTable>
              </div>
            </>
          </Panel>
);
}
